import { getPermissions } from "@/helper/collection";

export const MasterRoutes = {
  path: "master",
  redirect: "/master",
  name: "Masters",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "",
      component: () => import("@/components/Pages/MasterContainer/hoMasters"),
    },
    // {
    //     path: 'movie-status',
    //     name: 'Movie Status',
    //     component: () => import('@/components/Pages/MasterContainer/movieStatus'),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //     path: 'add-movie-status',
    //     name: 'Add Movie Status',
    //     component: () => import('@/components/Pages/AddContainer/addMovieStatus'),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //     path: 'edit-movie-status',
    //     name: 'Edit Movie Status',
    //     component: () => import('@/components/Pages/EditContainer/editMovieStatus'),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //     path: 'view-movie-status',
    //     name: 'View Movie Status',
    //     component: () => import('@/components/Pages/DetailsContainer/viewMovieStatus'),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //   path: "movies",
    //   name: "Movie",
    //   component: () => import("@/components/Pages/MasterContainer/movies"),
    //   meta: {
    //     permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //   }
    // },

    // RAW MATERIALS
    // {
    //   path: "raw-materials",
    //   name: "Raw Materials",
    //   component: () => import("@/components/Pages/MasterContainer/rawMaterials"),
    //   meta: {
    //     permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //   }
    // },
    // {
    //   path: "add-raw-material",
    //   name: "Add Raw Material",
    //   component: () => import("@/components/Pages/AddContainer/addRawMaterial"),
    //   meta: {
    //     permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //   }
    // },
    // {
    //   path: "edit-raw-material",
    //   name: "Edit Raw Material",
    //   component: () => import("@/components/Pages/EditContainer/editRawMaterial"),
    //   meta: {
    //     permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //   }
    // },
    // {
    //   path: "view-raw-material",
    //   name: "View Raw Material",
    //   component: () => import("@/components/Pages/DetailsContainer/viewRawMaterial"),
    //   meta: {
    //     permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //   }
    // },

    {
      path: "image-gallery",
      name: "Image Gallery",
      component: () => import("@/components/Pages/ImageGallery/viewImages"),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "HoManager",
            "PosOperator",
            "PosFnBOperator",
            "RolePos",
            "BoxOfficeFnbOperator",
          ],
          false,
          "",
          175,
          1
        ),
      },
    },
    {
      path: "image-gallery-modal",
      name: "Image Gallery Modal",
      component: () =>
        import("@/components/Pages/ImageGallery/imageGalleryModal"),
      meta: {
        permissions: getPermissions(
          [
            "SuperAdmin",
            "HoManager",
            "PosOperator",
            "PosFnBOperator",
            "RolePos",
            "BoxOfficeFnbOperator",
          ],
          false,
          "",
          175,
          2
        ),
      },
    },
    {
      path: "checklist-categories",
      name: "Checklist Categories",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CheckListCategoriesComponents/checkListCategories.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          126,
          1
        ),
      },
    },
    {
      path: "add-checklist-category",
      name: "Add Checklist Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CheckListCategoriesComponents/addChecklistCategory.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          126,
          2
        ),
      },
    },
    {
      path: "edit-checklist-category/:cc_id",
      name: "Edit Checklist Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CheckListCategoriesComponents/editChecklistCategory.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          126,
          2
        ),
      },
    },
    {
      path: "view-checklist-category/:cc_id",
      name: "View Checklist Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CheckListCategoriesComponents/viewChecklistCategory.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          126,
          1
        ),
      },
    },
    {
      path: "banners",
      name: "Web Banners",
      component: () =>
        import(
          "../components/Pages/MasterContainer/BannerComponents/banners.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          127,
          1
        ),
      },
    },
    {
      path: "add-banner",
      name: "Add Banner",
      component: () =>
        import(
          "../components/Pages/MasterContainer/BannerComponents/addBanner.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          127,
          2
        ),
      },
    },
    {
      path: "edit-banner/:b_id",
      name: "Edit Banner",
      component: () =>
        import(
          "../components/Pages/MasterContainer/BannerComponents/editBanner.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          127,
          2
        ),
      },
    },
    {
      path: "booking-sources",
      name: "Booking Sources",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BookingSourceComponents/bookingSources"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          50,
          1
        ),
      },
    },
    {
      path: "add-booking-source",
      name: "Add Booking Source",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BookingSourceComponents/addBookingSource"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          50,
          2
        ),
      },
    },
    {
      path: "edit-booking-source",
      name: "Edit Booking Source",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BookingSourceComponents/editBookingSource"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          50,
          2
        ),
      },
    },
    {
      path: "view-booking-source",
      name: "View Booking Source",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BookingSourceComponents/viewBookingSource"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          50,
          1
        ),
      },
    },
    {
      path: "booking-user-category",
      name: "Booking User Sources",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BookingUserCategoryComponents/bookingUserCategory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          69,
          1
        ),
      },
    },
    {
      path: "add-booking-user-category",
      name: "Add Booking user-category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BookingUserCategoryComponents/addBookingUserCategory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          69,
          2
        ),
      },
    },
    {
      path: "edit-booking-user-category",
      name: "Edit Booking user-category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BookingUserCategoryComponents/editBookingUserCategory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          69,
          2
        ),
      },
    },
    {
      path: "view-booking-user-category",
      name: "View Booking user-category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BookingUserCategoryComponents/viewBookingUserCategory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          69,
          1
        ),
      },
    },
    {
      path: "tax-types",
      name: "Tax Types",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ChargeTypesComponents/chargeTypes"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          45,
          1
        ),
      },
    },
    {
      path: "add-tax-type",
      name: "Add Tax Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ChargeTypesComponents/addChargeType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          45,
          2
        ),
      },
    },
    {
      path: "edit-tax-type",
      name: "Edit Tax Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ChargeTypesComponents/editChargeType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          45,
          2
        ),
      },
    },
    {
      path: "view-tax-type",
      name: "View Tax Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ChargeTypesComponents/viewChargeType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          45,
          1
        ),
      },
    },
    {
      path: "image-settings",
      name: "Image Settings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ImageSettingsComponents/imageSettings"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          56,
          1
        ),
      },
    },
    {
      path: "add-image-setting",
      name: "Add Image Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ImageSettingsComponents/addImageSetting"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          56,
          2
        ),
      },
    },
    {
      path: "edit-image-setting",
      name: "Edit Image Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ImageSettingsComponents/editImageSetting"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          56,
          2
        ),
      },
    },
    {
      path: "view-image-setting",
      name: "View Image Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ImageSettingsComponents/viewImageSetting"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          56,
          1
        ),
      },
    },
    // COUNTRY
    {
      path: "countries",
      name: "Country",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CountriesComponents/countries"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          41,
          1
        ),
      },
    },
    {
      path: "add-country",
      name: "Add Country",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CountriesComponents/addCountry"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          41,
          2
        ),
      },
    },
    {
      path: "edit-country",
      name: "Edit Country",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CountriesComponents/editCountry"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          41,
          2
        ),
      },
    },
    {
      path: "view-country",
      name: "View Country",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CountriesComponents/viewCountry"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          41,
          1
        ),
      },
    },
    {
      path: "cities",
      name: "City",
      component: () =>
        import("@/components/Pages/MasterContainer/CityComponents/city"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          43,
          1
        ),
      },
    },
    {
      path: "regions",
      name: "Region",
      component: () =>
        import("@/components/Pages/MasterContainer/RegionComponent/ListRegion"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          174,
          1
        ),
      },
    },
    {
      path: "add-region",
      name: "Add Region",
      component: () =>
        import("@/components/Pages/MasterContainer/RegionComponent/AddRegion"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          174,
          1
        ),
      },
    },
    {
      path: "edit-region",
      name: "Edit Region",
      component: () =>
        import("@/components/Pages/MasterContainer/RegionComponent/EditRegion"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          174,
          1
        ),
      },
    },
    {
      path: "add-city",
      name: "Add City",
      component: () =>
        import("@/components/Pages/MasterContainer/CityComponents/addCity"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          43,
          2
        ),
      },
    },
    {
      path: "edit-city",
      name: "Edit City",
      component: () =>
        import("@/components/Pages/MasterContainer/CityComponents/editCity"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          43,
          2
        ),
      },
    },
    {
      path: "view-city",
      name: "View City",
      component: () =>
        import("@/components/Pages/MasterContainer/CityComponents/viewCity"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          43,
          1
        ),
      },
    },
    {
      path: "crews",
      name: "Crew",
      component: () =>
        import("@/components/Pages/MasterContainer/CrewComponents/crew"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          48,
          1
        ),
      },
    },
    {
      path: "add-crew",
      name: "Add Crew",
      component: () =>
        import("@/components/Pages/MasterContainer/CrewComponents/addCrew"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          48,
          2
        ),
      },
    },
    {
      path: "edit-crew",
      name: "Edit Crew",
      component: () =>
        import("@/components/Pages/MasterContainer/CrewComponents/editCrew"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          48,
          2
        ),
      },
    },
    {
      path: "view-crew",
      name: "View Crew",
      component: () =>
        import("@/components/Pages/MasterContainer/CrewComponents/viewCrew"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          48,
          1
        ),
      },
    },
     {
      path: "cast-crew",
      name: "Cast & Crew Details",
      component: () =>
        import("@/components/Pages/MasterContainer/CastNCrewComponents/GetCastNCrewMaster"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          48,
          1
        ),
      },
    },
    {
      path: "add-cast-crew",
      name: "Add Cast Crew",
      component: () =>
        import("@/components/Pages/MasterContainer/CastNCrewComponents/AddCastNCrewMaster"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          48,
          2
        ),
      },
    },
    {
      path: "edit-cast-crew",
      name: "Edit Cast Crew",
      component: () =>
        import("@/components/Pages/MasterContainer/CastNCrewComponents/UpdateCastNCrewMaster"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          48,
          2
        ),
      },
    },

    {
      path: "currencies",
      name: "Currency",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CurrencyComponents/currency"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          49,
          1
        ),
      },
    },

    {
      path: "add-currency",
      name: "Add Currency",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CurrencyComponents/addCurrency"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          49,
          2
        ),
      },
    },
    {
      path: "edit-currency",
      name: "Edit Currency",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CurrencyComponents/editCurrency"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          49,
          2
        ),
      },
    },
    {
      path: "view-currency",
      name: "View Currency",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CurrencyComponents/viewCurrency"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          49,
          1
        ),
      },
    },

    {
      path: "currencies-conversion",
      name: "Currency Conversion",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CurrencyConversionComponents/currencyConversion"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          176,
          1
        ),
      },
    },
    {
      path: "add-currency-conversion",
      name: "Add Currency Conversion",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CurrencyConversionComponents/addCurrencyConversion"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          176,
          2
        ),
      },
    },
    {
      path: "edit-currency-conversion",
      name: "Edit Currency Conversion",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CurrencyConversionComponents/editCurrencyConversion"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          176,
          2
        ),
      },
    },
    {
      path: "view-currency-conversion",
      name: "View Currency Conversion",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CurrencyConversionComponents/viewCurrencyConversion"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          176,
          1
        ),
      },
    },

    //Ticket type

    {
      path: "ticket-type",
      name: "Ticket Type",
      component: () =>
        import("@/components/Pages/MasterContainer/TicketType/listTicketType"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          165,
          1
        ),
      },
    },
    {
      path: "add-ticket-type",
      name: "Add Ticket Type",
      component: () =>
        import("@/components/Pages/MasterContainer/TicketType/addTicketType"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          165,
          1
        ),
      },
    },
    {
      path: "edit-ticket-type",
      name: "Edit Ticket Type",
      component: () =>
        import("@/components/Pages/MasterContainer/TicketType/editTicketType"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          165,
          1
        ),
      },
    },

    // DENOMINATIONS
    {
      path: "denominations",
      name: "Denominations",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/DenominationsComponents/denominations"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          44,
          1
        ),
      },
    },
    {
      path: "add-denomination",
      name: "Add Denominations",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/DenominationsComponents/addDenomination"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          44,
          2
        ),
      },
    },
    {
      path: "edit-denomination",
      name: "Edit Denominations",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/DenominationsComponents/editDenomination"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          44,
          2
        ),
      },
    },

    {
      path: "view-denomination",
      name: "View Denominations",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/DenominationsComponents/viewDenomination"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          44,
          1
        ),
      },
    },

    // F & B PRICE
    // {
    //     path: "food-and-beverages-prices",
    //     name: "Food and Beverages Price",
    //     component: () => import("@/components/Pages/MasterContainer/foodAndBeveragesPrice"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },

    // {
    //     path: "booking-discount",
    //     name: "Booking Discount",
    //     component: () => import("@/components/Pages/MasterContainer/BookingDiscountComponent/bookingDiscount"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //     path: "add-booking-discount",
    //     name: "Add Booking Discount",
    //     component: () => import("@/components/Pages/MasterContainer/BookingDiscountComponent/addbookingDiscount"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //     path: "edit-booking-discount",
    //     name: "Edit Booking Discount",
    //     component: () => import("@/components/Pages/MasterContainer/BookingDiscountComponent/editbookingDiscount"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    // {
    //     path: "details-booking-discount",
    //     name: "Details Booking Discount",
    //     component: () => import("@/components/Pages/MasterContainer/BookingDiscountComponent/detailsbookingDiscount"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    {
      path: "backup-settings",
      name: "Backup Settings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BackupSettingComponent/backupSettings"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          51,
          1
        ),
      },
    },
    {
      path: "add-backup-settings",
      name: "Add Backup Settings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BackupSettingComponent/addBackupSettings"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          51,
          2
        ),
      },
    },
    {
      path: "edit-backup-settings",
      name: "Edit Backup Settings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BackupSettingComponent/editBackupSettings"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          51,
          2
        ),
      },
    },
    {
      path: "view-backup-settings",
      name: "View Backup Settings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BackupSettingComponent/viewBackupSettings"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          51,
          1
        ),
      },
    },
    // PAYMENT
    {
      path: "payment-modes",
      name: "Payment Mode",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/PaymentModesComponents/paymentModes"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          61,
          1
        ),
      },
    },
    {
      path: "add-payment-mode",
      name: "Add Payment Mode",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/PaymentModesComponents/addPaymentMode"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          61,
          2
        ),
      },
    },
    {
      path: "edit-payment-mode",
      name: "Edit Payment Mode",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/PaymentModesComponents/editPaymentMode"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          61,
          2
        ),
      },
    },
    {
      path: "view-payment-mode",
      name: "View Payment Mode",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/PaymentModesComponents/viewPaymentMode"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          61,
          1
        ),
      },
    },
    {
      path: "add-ticket-price-configuration",
      name: "Add Ticket Price Configuration",
      component: () =>
        import(
          "@/components/Pages/CinemaContainer/TicketPriceConfigurationComponents/addTicketPriceConfiguration"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          153,
          2
        ),
      },
    },
    {
      path: "edit-ticket-price-configuration",
      name: "Edit Ticket Price Configuration",
      component: () =>
        import(
          "@/components/Pages/CinemaContainer/TicketPriceConfigurationComponents/editTicketPriceConfiguration"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          153,
          2
        ),
      },
    },
    {
      path: "view-ticket-price-configuration",
      name: "Details Ticket Price Configuration",
      component: () =>
        import(
          "@/components/Pages/CinemaContainer/TicketPriceConfigurationComponents/viewTicketPriceConfiguration"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          153,
          1
        ),
      },
    },
    {
      path: "ticket-price-configurations",
      name: "Ticket Price Configuration",
      component: () =>
        import(
          "@/components/Pages/CinemaContainer/TicketPriceConfigurationComponents/ticketPriceConfiguration"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          153,
          1
        ),
      },
    },
    // {
    //     path: "ticket-prices",
    //     name: "Ticket Price",
    //     component: () => import("@/components/Pages/MasterContainer/ticketPrice"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },
    {
      path: "features",
      name: "Features",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/FeaturesComponents/features"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          52,
          1
        ),
      },
    },
    {
      path: "add-feature",
      name: "Add Features",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/FeaturesComponents/addFeature"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          52,
          2
        ),
      },
    },
    {
      path: "edit-feature",
      name: "Edit Features",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/FeaturesComponents/editFeature"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          52,
          2
        ),
      },
    },
    {
      path: "view-feature",
      name: "View Feature",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/FeaturesComponents/viewFeature"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          52,
          1
        ),
      },
    },
    // F & B PRICE CONFIGURATION
    // {
    //     path: 'food-and-beverages-price-configuration',
    //     name: 'Food And Beverages Price Configuration',
    //     component: () => import('@/components/Pages/MasterContainer/foodAndBeveragesPriceConfiguration'),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin', 'CinemaManager', 'HoManager'], false, '')
    //     }
    // },

    {
      path: "ratings",
      name: "Ratings",
      component: () =>
        import("@/components/Pages/MasterContainer/RatingsComponents/ratings"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          47,
          1
        ),
      },
    },
    {
      path: "add-rating",
      name: "Add Ratings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/RatingsComponents/addRating"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          47,
          2
        ),
      },
    },
    {
      path: "edit-rating",
      name: "Edit Ratings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/RatingsComponents/editRating"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          47,
          2
        ),
      },
    },
    {
      path: "view-rating",
      name: "View Ratings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/RatingsComponents/viewRating"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          47,
          1
        ),
      },
    },

    // // PRODUCTION
    // {
    //   path: "productions",
    //   name: "Production",
    //   component: () =>
    //     import(
    //       "@/components/Pages/MasterContainer/ProductionCompany/production"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       46,
    //       1
    //     ),
    //   },
    // },
    // {
    //   path: "add-production",
    //   name: "Add Production",
    //   component: () =>
    //     import(
    //       "@/components/Pages/MasterContainer/ProductionCompany/addProduction"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       46,
    //       2
    //     ),
    //   },
    // },
    // {
    //   path: "edit-production",
    //   name: "Edit Production",
    //   component: () =>
    //     import(
    //       "@/components/Pages/MasterContainer/ProductionCompany/editProductionV2"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       46,
    //       2
    //     ),
    //   },
    // },
    // {
    //   path: "view-production",
    //   name: "View Production",
    //   component: () =>
    //     import(
    //       "@/components/Pages/MasterContainer/ProductionCompany/viewProduction"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       46,
    //       1
    //     ),
    //   },
    // },

    // REFUND REASONS
    {
      path: "refund-reasons",
      name: "Refund Reasons",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/RefundReasonComponents/refundReasons"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          62,
          1
        ),
      },
    },
    {
      path: "edit-refund-reason",
      name: "Edit Refund Reasons",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/RefundReasonComponents/editRefundReason"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          62,
          2
        ),
      },
    },
    {
      path: "add-refund-reason",
      name: "Add Refund Reasons",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/RefundReasonComponents/addRefundReason"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          62,
          2
        ),
      },
    },
    {
      path: "view-refund-reason",
      name: "View Refund Reasons",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/RefundReasonComponents/viewRefundReason"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          62,
          1
        ),
      },
    },

    // GENRE
    {
      path: "genres",
      name: "Genre",
      component: () =>
        import("@/components/Pages/MasterContainer/GenreComponents/genre"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          53,
          1
        ),
      },
    },
    {
      path: "add-genre",
      name: "Add Genre",
      component: () =>
        import("@/components/Pages/MasterContainer/GenreComponents/addGenre"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          53,
          2
        ),
      },
    },
    {
      path: "edit-genre",
      name: "Edit Genre",
      component: () =>
        import("@/components/Pages/MasterContainer/GenreComponents/editGenre"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          53,
          2
        ),
      },
    },
    {
      path: "view-genre",
      name: "View Genre",
      component: () =>
        import("@/components/Pages/MasterContainer/GenreComponents/viewGenre"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          53,
          1
        ),
      },
    },
    // HARDWARE
    {
      path: "hardwares",
      name: "Hardware",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/HardwareComponents/hardware"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          54,
          1
        ),
      },
    },
    {
      path: "add-hardware",
      name: "Add Hardware",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/HardwareComponents/addHardware"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          54,
          2
        ),
      },
    },
    {
      path: "edit-hardware",
      name: "Edit Hardware",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/HardwareComponents/editHardware"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          54,
          2
        ),
      },
    },
    {
      path: "view-hardware",
      name: "View Hardware",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/HardwareComponents/viewHardware"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          54,
          1
        ),
      },
    },
    //Hardware Locations
    {
      path: "hardware-locations",
      name: "Hardware Locations",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/HardwareComponents/HardwareLocations"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          236,
          1
        ),
      },
    },
    {
      path: "add-hardware-location",
      name: "Add Hardware Location",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/HardwareComponents/AddHardwareLocation"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          236,
          2
        ),
      },
    },
    {
      path: "edit-hardware-location",
      name: "Edit Hardware Location",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/HardwareComponents/EditHardwareLocation"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          236,
          2
        ),
      },
    },
    // LANGUAGE
    {
      path: "languages",
      name: "View Languages",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/LanguageComponents/language"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          55,
          1
        ),
      },
    },
    {
      path: "add-language",
      name: "Add Language",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/LanguageComponents/addLanguage"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          55,
          2
        ),
      },
    },
    {
      path: "edit-language",
      name: "Edit Language",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/LanguageComponents/editLanguage"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          55,
          2
        ),
      },
    },
    {
      path: "view-language",
      name: "View Single Language",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/LanguageComponents/viewLanguage"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          55,
          1
        ),
      },
    },
    // MODULES
    {
      path: "modules",
      name: "Modules",
      component: () =>
        import("@/components/Pages/MasterContainer/ModulesComponents/modules"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          59,
          1
        ),
      },
    },
    {
      path: "add-module",
      name: "Add Module",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ModulesComponents/addModule"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          59,
          2
        ),
      },
    },
    {
      path: "edit-module",
      name: "Edit Module",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ModulesComponents/editModule"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          59,
          2
        ),
      },
    },
    {
      path: "view-module",
      name: "View Module",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ModulesComponents/viewModule"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          59,
          1
        ),
      },
    },
    // Movie Format
    {
      path: "movie-formats",
      name: "Movie Format",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieFormatComponents/movieFormat"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          57,
          1
        ),
      },
    },
    {
      path: "Add-movie-format",
      name: "Add Movie Format",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieFormatComponents/addMovieFormat"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          57,
          2
        ),
      },
    },
    {
      path: "view-movie-format",
      name: "View Movie Format",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieFormatComponents/viewMovieFormat"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          57,
          1
        ),
      },
    },
    {
      path: "Edit-movie-format",
      name: "Edit Movie Format",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieFormatComponents/editMovieFormat"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          57,
          2
        ),
      },
    },

    //Organizations
    {
      path: "organizations",
      name: "Organizations",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/OrganizationComponents/organizations"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          60,
          1
        ),
      },
    },
    {
      path: "Add-organization",
      name: "Add Organization",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/OrganizationComponents/addOrganization"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          60,
          2
        ),
      },
    },
    {
      path: "view-organization",
      name: "View Organization",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/OrganizationComponents/viewOrganization"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          60,
          1
        ),
      },
    },
    {
      path: "Edit-organization",
      name: "Edit Organization",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/OrganizationComponents/editOrganization"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          60,
          2
        ),
      },
    },
    // SEAT RESERVATIONS
    {
      path: "seat-reservation-types",
      name: "Seat Reservation Types",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SeatReservationTypeComponents/seatReservationType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          65,
          1
        ),
      },
    },
    {
      path: "add-seat-reservation-type",
      name: "Add Seat Reservation Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SeatReservationTypeComponents/addSeatReservationType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          65,
          2
        ),
      },
    },
    {
      path: "edit-seat-reservation-type",
      name: "Edit Seat Reservation Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SeatReservationTypeComponents/editSeatReservationType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          65,
          2
        ),
      },
    },
    {
      path: "view-seat-reservation-type",
      name: "View Seat Reservation Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SeatReservationTypeComponents/viewSeatReservationType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          65,
          1
        ),
      },
    },
    // WEEKDAYS
    {
      path: "weekdays",
      name: "Weekdays",
      component: () =>
        import("@/components/Pages/MasterContainer/WeekdayComponents/weekdays"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          68,
          1
        ),
      },
    },
    {
      path: "edit-weekday",
      name: "Edit Weekday",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/WeekdayComponents/editWeekday"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          68,
          2
        ),
      },
    },
    {
      path: "view-weekday",
      name: "View Weekday",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/WeekdayComponents/viewWeekday"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          68,
          1
        ),
      },
    },
    // MOVIE CATEGORIES
    {
      path: "movie-categories",
      name: "Movie Categories",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieCategoriesComponents/movieCategories"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          58,
          1
        ),
      },
    },
    {
      path: "add-movie-category",
      name: "Add Movie Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieCategoriesComponents/addMovieCategory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          58,
          2
        ),
      },
    },
    {
      path: "edit-movie-category",
      name: "Edit Movie Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieCategoriesComponents/editMovieCategory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          58,
          2
        ),
      },
    },
    {
      path: "view-movie-category",
      name: "View Movie Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieCategoriesComponents/viewMovieCategory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          58,
          1
        ),
      },
    },

    //Territory
    {
      path: "territory",
      name: "Territory",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TerritoryComponents/territory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          307,
          1
        ),
      },
    },
    // {
    //   path: "add-territory",
    //   name: "Add Territory",
    //   component: () =>
    //     import(
    //       "@/components/Pages/MasterContainer/TerritoryComponents/addTerritory"
    //     ),
    //   meta: {
    //     permissions: getPermissions(
    //       ["SuperAdmin", "CinemaManager", "HoManager"],
    //       false,
    //       "",
    //       307,
    //       2
    //     ),
    //   },
    // },
    {
      path: "edit-territory",
      name: "Edit territory",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TerritoryComponents/addTerritory"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          307,
          2
        ),
      },
    },

    // SIGNAGE TYPES
    {
      path: "signage-types",
      name: "Signage Types",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SignageTypesComponents/signageTypes"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          63,
          1
        ),
      },
    },
    {
      path: "add-signage-type",
      name: "Add Signage Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SignageTypesComponents/addSignageType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          63,
          2
        ),
      },
    },
    {
      path: "edit-signage-type",
      name: "Edit Signage Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SignageTypesComponents/editSignageType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          63,
          2
        ),
      },
    },
    {
      path: "view-signage-type",
      name: "View Signage Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SignageTypesComponents/viewSignageType"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          63,
          1
        ),
      },
    },

    // STATES
    {
      path: "states",
      name: "States",
      component: () =>
        import("@/components/Pages/MasterContainer/StatesComponents/states"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          42,
          1
        ),
      },
    },
    {
      path: "add-state",
      name: "Add State",
      component: () =>
        import("@/components/Pages/MasterContainer/StatesComponents/addState"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          42,
          2
        ),
      },
    },
    {
      path: "edit-state",
      name: "Edit State",
      component: () =>
        import("@/components/Pages/MasterContainer/StatesComponents/editState"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          42,
          2
        ),
      },
    },
    {
      path: "view-state",
      name: "View State",
      component: () =>
        import("@/components/Pages/MasterContainer/StatesComponents/viewState"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          42,
          1
        ),
      },
    },
    // STATUSES
    {
      path: "statuses",
      name: "Statuses",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/StatusesComponents/statuses"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          66,
          1
        ),
      },
    },
    {
      path: "add-status",
      name: "Add Status",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/StatusesComponents/addStatus"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          66,
          2
        ),
      },
    },
    {
      path: "edit-status",
      name: "Edit Status",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/StatusesComponents/editStatus"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          66,
          2
        ),
      },
    },
    {
      path: "view-statuses",
      name: "View Statuses",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/StatusesComponents/viewStatus"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          66,
          1
        ),
      },
    },
    {
      path: "unit-converter",
      name: "Unit Converter",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/unitConverterComponents/unitConverter"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          128,
          1
        ),
      },
    },
    // UNIT OF MEASUREMENT
    {
      path: "unit-of-measurment",
      name: "Unit Of Measurment",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/UnitofMesurementComponents/unitOfMeasurement"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          67,
          1
        ),
      },
    },
    {
      path: "add-unit-of-measurment",
      name: "Add Unit Of Measurment",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/UnitofMesurementComponents/addUnitOfMeasurement"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          67,
          2
        ),
      },
    },
    {
      path: "edit-unit-of-measurment",
      name: "Edit Unit Of Measurment",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/UnitofMesurementComponents/editUnitOfMeasurement"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          67,
          2
        ),
      },
    },
    {
      path: "view-unit-of-measurment",
      name: "View Unit Of Measurment",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/UnitofMesurementComponents/viewUnitOfMeasurement"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          67,
          1
        ),
      },
    },
    {
      path: "document-verification",
      name: "Document Verification",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/DocumentVerification/documentVerification"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          70,
          1
        ),
      },
    },
    {
      path: "add-document-verification",
      name: "Add Document Verification",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/DocumentVerification/addDocumentVerification"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          70,
          2
        ),
      },
    },
    {
      path: "edit-document-verification",
      name: "Edit Document Verification",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/DocumentVerification/editDocumentVerification"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          70,
          2
        ),
      },
    },
    {
      path: "view-document-verification",
      name: "View Document Verification",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/DocumentVerification/viewDocumentVerification"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          70,
          1
        ),
      },
    },
    {
      path: "ticket-templates",
      name: "Ticket Templates",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TicketTemplates/ticketTemplates.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          71,
          1
        ),
      },
    },
    {
      path: "add-ticket-templates",
      name: "Add Ticket Templates",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TicketTemplates/addTicketTemplates.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          71,
          2
        ),
      },
    },
    {
      path: "edit-ticket-templates",
      name: "Edit Ticket Templates",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TicketTemplates/editTicketTemplates.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          71,
          2
        ),
      },
    },
    {
      path: "view-ticket-templates",
      name: "View Ticket Templates",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TicketTemplates/viewTicketTemplates.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          71,
          1
        ),
      },
    },
    {
      path: "receipts",
      name: "Receipts",
      component: () =>
        import("@/components/Pages/MasterContainer/Receipts/receipts.vue"),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 72, 1),
      },
    },
    {
      path: "receipts-template",
      name: "Receipts Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ReceiptsTemplate/receiptsTemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 73, 1),
      },
    },
    {
      path: "add-receipts-template",
      name: "Add Receipts Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ReceiptsTemplate/addReceiptsTemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 73, 2),
      },
    },
    {
      path: "edit-receipts-template",
      name: "Edit Receipts Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ReceiptsTemplate/editReceiptsTemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 73, 2),
      },
    },
    {
      path: "view-receipts-template",
      name: "View Receipts Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ReceiptsTemplate/viewReceiptsTemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 73, 1),
      },
    },
    {
      path: "cinema-ticket-templates",
      name: "Cinema Ticket Templates",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CinemaTicketTemplates/CinematicketTemplates.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 74, 1),
      },
    },
    {
      path: "add-cinema-ticket-templates",
      name: "Add Cinema Ticket Templates",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CinemaTicketTemplates/addCinemaTicketTemplates.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 74, 2),
      },
    },
    {
      path: "edit-cinema-ticket-templates",
      name: "Edit Cinema Ticket Templates",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CinemaTicketTemplates/editCinemaTicketTemplates.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 74, 2),
      },
    },
    {
      path: "view-cinema-ticket-templates",
      name: "View Cinema Ticket Templates",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CinemaTicketTemplates/viewCinemaTicketTemplates.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 74, 1),
      },
    },
    {
      path: "auto-email-report",
      name: "Auto Email Report",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AutoEmailReportComponents/listautoemailreport.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 75, 1),
      },
    },
    {
      path: "add-auto-email-report",
      name: "Add Auto Email Report",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AutoEmailReportComponents/addautoemailreport.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 75, 2),
      },
    },
    // {
    //   path: "auto-emailer-v2",
    //   name: "Auto Emailer V2",
    //   component: () =>
    //     import(
    //       "@/components/Pages/MasterContainer/AutoEmailerV2/listautoemailreport.vue"
    //     ),
    //   meta: {
    //     permissions: getPermissions(["SuperAdmin"], false, "", 75, 1)
    //   }
    // },
    {
      path: "auto-email-v3",
      name: "Auto Email V3",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AutoEmailerV2/autoemailnew.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 75, 1),
      },
    },
    {
      path: "add-auto-emailer-v2",
      name: "Add Auto Email Report",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AutoEmailerV2/addautoemailreport.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 75, 2),
      },
    },
    {
      path: "auto-emailer-v2-logs",
      name: "Auto Email Report Logs",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AutoEmailerV2/autoemailreportlogs.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 75, 2),
      },
    },
    {
      path: "add-auto-emailer-v2/:am_id",
      name: "Edit Auto Email Report",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AutoEmailerV2/addautoemailreport.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 75, 2),
      },
    },
    {
      path: "edit-auto-email-report",
      name: "Edit Auto Email Report",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AutoEmailReportComponents/editautoemailreport.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 75, 2),
      },
    },
    // },
    {
      path: "auto-email-v3",
      name: "Auto Email V3",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AutoEmailerV2/autoemailnew.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 75, 1),
      },
    },
    {
      path: "add-inventory-mails",
      name: "Add Inventory Mails",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/InventoryManagements/InventoryMails.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 346, 2),
      },
    },
    {
      path: "email-template",
      name: "Email Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/EmailTemplateComponents/listemailtemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 76, 1),
      },
    },
    {
      path: "add-email-template",
      name: "Add Email Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/EmailTemplateComponents/addemailtemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 76, 2),
      },
    },
    {
      path: "edit-email-template",
      name: "Edit Email Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/EmailTemplateComponents/editemailtemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 76, 2),
      },
    },
    {
      path: "view-email-template",
      name: "View Email Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/EmailTemplateComponents/viewemailtemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 76, 1),
      },
    },
    {
      path: "sms-template",
      name: "SMS Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SMSTemplateComponents/listsmstemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 77, 1),
      },
    },
    {
      path: "add-sms-template",
      name: "Add SMS Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SMSTemplateComponents/addsmstemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 77, 2),
      },
    },
    {
      path: "edit-sms-template",
      name: "Edit SMS Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SMSTemplateComponents/editsmstemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 77, 2),
      },
    },
    {
      path: "view-sms-template",
      name: "View SMS Template",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SMSTemplateComponents/viewsmstemplate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 77, 1),
      },
    },
    {
      path: "support-ticket-category",
      name: "Support Ticket Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SupportTicketCategoryComponents/listSupportTicketCategory.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 129, 1),
      },
    },
    {
      path: "add-support-ticket-category",
      name: "Add Support Ticket Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SupportTicketCategoryComponents/addSupportTicketCategory.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 129, 2),
      },
    },
    {
      path: "edit-support-ticket-category",
      name: "Edit Support Ticket Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SupportTicketCategoryComponents/editSupportTicketCategory.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 129, 2),
      },
    },
    {
      path: "view-support-ticket-category",
      name: "View Support Ticket Category",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SupportTicketCategoryComponents/viewSupportTicketCategory.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 129, 1),
      },
    },
    {
      path: "sound-formats",
      name: "Sound Formats",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SoundFormatsComponent/soundFormats.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 152, 1),
      },
    },
    {
      path: "add-sound-format",
      name: "Add Sound Format",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SoundFormatsComponent/addSoundFormat.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 152, 2),
      },
    },
    {
      path: "edit-sound-format/:sound_format_id",
      name: "Edit Sound Format",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SoundFormatsComponent/editSoundFormat.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 152, 2),
      },
    },
    {
      path: "view-sound-format/:sound_format_id",
      name: "View Sound Format",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/SoundFormatsComponent/viewSoundFormat.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 152, 1),
      },
    },
    {
      path: "schedule-comments-master",
      name: "Schedule Comments",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/commentComponent/comments.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 141, 1),
      },
    },
    {
      path: "add-schedule-comment",
      name: "Add Schedule Comment",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/commentComponent/addComment.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 180, 2),
      },
    },
    {
      path: "edit-schedule-comment",
      name: "Edit Schedule Comment",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/commentComponent/editComment.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 180, 2),
      },
    },
    //Client
    {
      path: "clients",
      name: "Clients",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ClientComponent/clients.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 160, 1),
      },
    },
    {
      path: "add-client",
      name: "Add Client",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ClientComponent/addClient.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 160, 2),
      },
    },
    {
      path: "edit-client",
      name: "Edit Client",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ClientComponent/editClient.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 160, 2),
      },
    },
    {
      path: "view-client",
      name: "View Client",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ClientComponent/viewClient.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 160, 1),
      },
    },
    // {
    //     path: "list-seo",
    //     name: "List Seo",
    //     component: () => import("@/components/Pages/MasterContainer/SeoComponents/listseo.vue"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin'], false, '')
    //     }
    // },
    // {
    //     path: "add-seo",
    //     name: "Add Seo",
    //     component: () => import("@/components/Pages/MasterContainer/SeoComponents/addseo.vue"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin'], false, '')
    //     }
    // },
    // {
    //     path: "edit-seo/:seo_meta_id",
    //     name: "Edit Seo",
    //     component: () => import("@/components/Pages/MasterContainer/SeoComponents/editSeo.vue"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin'], false, '')
    //     }
    // },
    // {
    //     path: "view-seo/:seo_meta_id",
    //     name: "View Seo",
    //     component: () => import("@/components/Pages/MasterContainer/SeoComponents/viewSeo.vue"),
    //     meta: {
    //         permissions: getPermissions(['SuperAdmin'], false, '')
    //     }
    // },
    {
      path: "custom-fields",
      name: "Custom Fields",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CustomFieldsComponents/CustomFields.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, ""),
      },
    },
    {
      path: "add-custom-fields/:module",
      name: "Add Custom Fields",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CustomFieldsComponents/addCustomFields.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, ""),
      },
    },
    {
      path: "global-options",
      name: "Global Options",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/GlobalOptionsComponents/globalOptions.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, ""),
      },
    },
    {
      path: "global-options-settings",
      name: "Global Options Settings",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/GlobalOptionsComponents/globalOptionsV2.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 203, 2),
      },
    },
    {
      path: "global-sync-manually",
      name: "Global Sync Manually",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/GlobalOptionsComponents/syncManuallyPage.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 354, 2),
      },
    },
    {
      path: "odoo-sync-logs",
      name: "Odoo Sync Logs",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/OdooSyncLogs/odooSyncLogs.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager", "CinemaManager"],
          false,
          "",
          357,
          2,
        ),
      },
    },
    {
      path: "private-global-options",
      name: "Private Global Options",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/GlobalOptionsComponents/globalOptionsPrivate.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, ""),
      },
    },
    {
      path: "key-pri/v3/key-v3/options/for-global",
      name: "Private Global Options Key",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/GlobalOptionsComponents/globalKeyOptions.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, ""),
      },
    },

    {
      path: "version",
      name: "Version",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/VersionComponent/version.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, ""),
      },
    },
    {
      path: "cinema-types",
      name: "Cinema Types",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CinemaTypeComponents/cinemaTypes.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 155, 1),
      },
    },
    {
      path: "add-cinema-type",
      name: "Add Cinema Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CinemaTypeComponents/addCinemaType.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 155, 2),
      },
    },
    {
      path: "edit-cinema-type/:cinema_type_id",
      name: "Edit Cinema Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CinemaTypeComponents/editCinemaType.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 155, 2),
      },
    },
    {
      path: "view-cinema-type/:cinema_type_id",
      name: "View Cinema Type",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/CinemaTypeComponents/viewCinemaType.vue"
        ),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 155, 1),
      },
    },
    {
      path: "tier-types",
      name: "Tier Types",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TierTypeComponents/tierTypes.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager"],
          false,
          "",
          156,
          1
        ), //Access given to HO (said by sanath on Slack(Group) on 28th Aug 2020)
      },
    },
    {
      path: "add-tier-types",
      name: "Add Tier Types",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TierTypeComponents/addTierType.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager"],
          false,
          "",
          156,
          2
        ),
      },
    },
    {
      path: "edit-tier-types/:tier_type_id",
      name: "Edit Tier Types",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TierTypeComponents/editTierType.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager"],
          false,
          "",
          156,
          2
        ),
      },
    },
    {
      path: "view-tier-types/:tier_type_id",
      name: "View Tier Types",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TierTypeComponents/viewTierType.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "HoManager"],
          false,
          "",
          156,
          1
        ),
      },
    },
    {
      path: "add-ons",
      name: "Add-ons",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AddonsComponents/addons.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          157,
          1
        ), //add module id from table
      },
    },
    {
      path: "add-add-ons",
      name: "Add Add-ons",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AddonsComponents/addAddons.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          157,
          2
        ),
      },
    },
    {
      path: "edit-add-ons",
      name: "Edit Add-ons",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AddonsComponents/editAddons.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          157,
          2
        ),
      },
    },
    {
      path: "view-add-ons",
      name: "View Add-ons",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AddonsComponents/viewAddons.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          157,
          1
        ),
      },
    },
    {
      path: "aspect-ratios",
      name: "Aspect Ratios",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AspectRatiosComponent/ListAspectRatio"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          181,
          1
        ),
      },
    },
    {
      path: "add-aspect-ratio",
      name: "Add Aspect Ratio",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AspectRatiosComponent/AddAspectRatio"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          181,
          2
        ),
      },
    },
    {
      path: "edit-aspect-ratio",
      name: "Edit Aspect Ratio",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/AspectRatiosComponent/EditAspectRatio"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          181,
          2
        ),
      },
    },

    /* Movie Resolution */
    {
      path: "movie-resolutions",
      name: "Movie Resolutions",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieResolutionComponent/ListMovieResolution"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          182,
          1
        ),
      },
    },
    {
      path: "add-movie-resolution",
      name: "Add Movie Resolution",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieResolutionComponent/AddMovieResolution"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          182,
          1
        ),
      },
    },
    {
      path: "edit-movie-resolution",
      name: "Edit Movie Resolution",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieResolutionComponent/EditMovieResolution"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          182,
          1
        ),
      },
    },

    /* Movie Experiences */
    {
      path: "movie-experiences",
      name: "Movie Experiences",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieExperienceComponent/ListMovieExperience"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          183,
          1
        ),
      },
    },
    {
      path: "add-movie-experience",
      name: "Add Movie Experience",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieExperienceComponent/AddMovieExperience"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          183,
          2
        ),
      },
    },
    {
      path: "edit-movie-experience",
      name: "Edit Movie Experience",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieExperienceComponent/EditMovieExperience"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          183,
          2
        ),
      },
    },
    {
      path: "translations-list",
      name: "Translations List",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TranslationsComponent/TranslationsList"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          195,
          1
        ),
      },
    },
    {
      path: "edit-translation/:t_id",
      name: "Edit Translation",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/TranslationsComponent/EditTranslation"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          195,
          2
        ),
      },
    },
    {
      path: "movie-labels",
      name: "Movie Labels",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieLabelComponents/listMovieLabels"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          194,
          1
        ),
      },
    },
    {
      path: "fnb-labels",
      name: "Fnb Labels",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/FNBLabelComponents/listFNBLabels"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          237,
          1
        ),
      },
    },
    {
      path: "add-movie-label",
      name: "Add Movie Label",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieLabelComponents/addMovieLabel"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          194,
          2
        ),
      },
    },
    {
      path: "add-fnb-label",
      name: "Add Fnb Label",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/FNBLabelComponents/addFNBLabel"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          237,
          2
        ),
      },
    },
    {
      path: "edit-movie-label",
      name: "Edit Movie Label",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/MovieLabelComponents/editMovieLabel"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          194,
          2
        ),
      },
    },
    {
      path: "edit-fnb-label",
      name: "Edit FnB Label",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/FNBLabelComponents/editFNBLabel"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          237,
          2
        ),
      },
    },
    {
      path: "referral-code",
      name: "Referral Codes",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ReferralCodeComponents/listCode"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          242,
          1
        ),
      },
    },
    {
      path: "edit-referral-code",
      name: "Edit Referral Code",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ReferralCodeComponents/editCode"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          242,
          2
        ),
      },
    },
    {
      path: "backup-restore-db",
      name: "Backup & Restore",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/BackupRestoreComponent/backupRestore.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          244,
          2
        ),
      },
    },
    {
      path: "screen-seat-type-group",
      name: "Screen Seat Type Group",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ScreenSeatTypeGroup/ListScreenSeatTypeGroup"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          194,
          1
        ),
      },
    },
    {
      path: "add-screen-seat-type-group",
      name: "Add Screen Seat Type Group",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ScreenSeatTypeGroup/AddScreenSeatTypeGroup"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          194,
          1
        ),
      },
    },
    {
      path: "edit-screen-seat-type-group",
      name: "Edit Screen Seat Type Group",
      component: () =>
        import(
          "@/components/Pages/MasterContainer/ScreenSeatTypeGroup/AddScreenSeatTypeGroup"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          194,
          1
        ),
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/masterRoutes.js